import Const from './ActionConst';
import _, { find } from 'lodash';
import { DO_NOT_TRACK, VIZ_OPTION_IDS } from '../../Constants';
import { VIZ_SELECTORS } from '../selectors/viz-selectors';
import DiscoverActions from './DiscoverActions';
import { IDiscovery } from '../../../discovery';

const Actions = {
  clearDashletError() {
    return dispatch => {
      dispatch({ type: Const.Dashlet.CLEAR_DASHLET_ERROR });
    };
  },
  openDiscovery(discovery: Partial<IDiscovery>, dashletId: string) {
    const {
      id: dashletDiscoveryId,
      name,
      dataset: { id: dashletDatasetId, annotations: datasetAnnotations },
      options,
    } = discovery?.viz;

    const runtimeFilters = VIZ_SELECTORS.getVizOption(
      options,
      VIZ_OPTION_IDS.runtimeFilters,
      {},
    );

    const datasetJson =
      find(datasetAnnotations, { key: 'datasetJson' })?.value || '';

    return (dispatch, getState) => {
      const {
        dashlet: { activeVisualizationId, isDashletSaving, activeDashletId },
      } = getState();
      if (isDashletSaving) {
        return;
      }
      if (
        activeVisualizationId !== dashletDiscoveryId ||
        activeDashletId !== dashletId
      ) {
        // Not tracked here: the dashlet load is counted once, by trackReportLoaded in mfe.utils.ts.
        dispatch(DiscoverActions.openDiscoveryTracked(discovery, DO_NOT_TRACK));

        // @NOTE we should eventually offload dashlet message passing to Sugar Core's BackboneJS
        window.top.postMessage(
          {
            type: 'SELECT_ID',
            dashletDatasetId,
            dashletDiscoveryId,
            dashletId,
            name,
            runtimeFilters,
            datasetJson,
          },
          window.location.origin,
        );

        dispatch({
          type: Const.Dashlet.OPEN_DASHLET_VIZ,
          dashletDatasetId,
          dashletDiscoveryId, //@NOTE rename dashletDiscoveryId because of DSC-3794
          activeDashletId: dashletId,
        });
      }
    };
  },
  closeDiscovery() {
    return dispatch => {
      dispatch({
        type: Const.Dashlet.CLOSE_DASHLET_VIZ,
      });
    };
  },
  setAvailableDiscoveries(discoveries) {
    return dispatch => {
      dispatch({
        type: Const.Dashlet.SET_AVAILABLE_DASHLET_DISCOVERIES,
        discoveries,
      });
    };
  },
};

export default Actions;
